import axios from "axios";
import { baseUrl } from "../config/EnVariables";
// const baseUrl = "http://localhost:8081/api";
const token = localStorage.getItem("access_token");
const user = JSON.parse(localStorage.getItem("user"));
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const Log = {
  getAll: () =>
    axios.get(
      `${baseUrl}/audit-logs/?branchId=${user?.branchId}`,

      { headers: headers }
    ),
};

export default Log;
